module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": "Edit Blog Post",
      "subtitle": ""
    }
  }), _vm._v(" "), _vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary xs-p-20"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-sm-3 col-lg-2 col-form-label",
    attrs: {
      "for": "txtTitle"
    }
  }, [_vm._v("Blog post title")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6 col-sm-9 col-lg-10"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleDetails.title),
      expression: "articleDetails.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtTitle"
    },
    domProps: {
      "value": _vm._s(_vm.articleDetails.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.articleDetails.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-sm-3 col-lg-2 col-form-label",
    attrs: {
      "for": "txtMetaTitle"
    }
  }, [_vm._v("Meta title")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6 col-sm-9 col-lg-10"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleDetails.meta_title),
      expression: "articleDetails.meta_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtMetaTitle"
    },
    domProps: {
      "value": _vm._s(_vm.articleDetails.meta_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.articleDetails.meta_title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-sm-3 col-lg-2 col-form-label",
    attrs: {
      "for": "txtMetaDescription"
    }
  }, [_vm._v("Meta description")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6 col-sm-9 col-lg-10"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleDetails.meta_desc),
      expression: "articleDetails.meta_desc"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtMetaDescription"
    },
    domProps: {
      "value": _vm._s(_vm.articleDetails.meta_desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.articleDetails.meta_desc = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-lg-4 col-form-label",
    attrs: {
      "for": "txtAuthor"
    }
  }, [_vm._v("Author")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6 col-lg-8"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleDetails.author),
      expression: "articleDetails.author"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "txtAuthor"
    },
    domProps: {
      "value": _vm._s(_vm.articleDetails.author)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.articleDetails.author = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-lg-4 col-form-label",
    attrs: {
      "for": "chkNotify"
    }
  }, [_vm._v("Notify admin on create")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6 col-lg-8"
  }, [_vm._c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleDetails.notify),
      expression: "articleDetails.notify"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "id": "chkNotify"
    },
    domProps: {
      "checked": Array.isArray(_vm.articleDetails.notify) ? _vm._i(_vm.articleDetails.notify, null) > -1 : (_vm.articleDetails.notify)
    },
    on: {
      "click": function($event) {
        var $$a = _vm.articleDetails.notify,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.articleDetails.notify = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.articleDetails.notify = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.articleDetails.notify = $$c
        }
      }
    }
  })])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row height-100"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 height-100"
  }, [_vm._c('div', {
    staticClass: "height-100"
  }, [_vm._c('FroalaEditor', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.articleDetails.content),
      expression: "articleDetails.content"
    }],
    ref: "editor",
    attrs: {
      "config": _vm.froalaConfig
    },
    domProps: {
      "value": (_vm.articleDetails.content)
    },
    on: {
      "input": function($event) {
        _vm.articleDetails.content = $event
      }
    }
  })], 1)])]), _vm._v(" "), (!_vm.valid) ? _vm._c('div', {
    staticClass: "alert alert-warning xs-mt-20"
  }, [_vm._v("\n            Please fill in all fields above.\n          ")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "save xs-pt-20"
  }, [_vm._c('router-link', {
    staticClass: "btn btn-xl",
    attrs: {
      "to": {
        name: 'blog-manager'
      }
    }
  }, [_vm._c('i', {
    staticClass: "icon mdi mdi-arrow-left"
  }), _vm._v("  Back")]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-primary btn-xl pull-right xs-ml-10",
    attrs: {
      "disabled": _vm.status !== '' || !_vm.valid
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-save"
  }), _vm._v("   Save")]), _vm._v(" "), (_vm.blogArticle && _vm.blogArticle.id > 0) ? _vm._c('button', {
    staticClass: "btn btn-danger btn-xl pull-right xs-ml-10",
    attrs: {
      "disabled": _vm.status !== ''
    },
    on: {
      "click": function($event) {
        _vm.deletePost()
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-trash"
  }), _vm._v("  Delete")]) : _vm._e(), _vm._v(" "), _vm._c('span', {
    staticClass: "pull-right xs-mr-10 xs-p-10 text-bold text-muted",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _vm._c('hr'), _vm._v(" "), (_vm.blogArticle) ? _vm._c('BlogCommentsList', {
    attrs: {
      "comments": _vm.blogArticle.comments,
      "show-delete": true,
      "articleId": _vm.blogArticle.id
    }
  }) : _vm._e()], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c71cc05e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/blog/posteditor.vue
// module id = 714
// module chunks = 1